import { IconButton } from '@patrianna/core-components'
import { ChevronLeft } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import classes from './styles.module.scss'

type BackButtonType = {
  handler?: () => void
  className?: string
  color?: 'white' | 'black'
  children?: any
}

export default function BackButton(props: BackButtonType) {
  return (
    <IconButton
      className={cx(props.className, classes.root, classes[props?.color || 'black'])}
      onClick={() => {
        props.handler?.()
      }}
      data-test='modal-back-button'
    >
      <ChevronLeft className={classes.icon} />

      {props.children}
    </IconButton>
  )
}
